import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Right",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.332 9.0013C17.332 4.39893 13.6011 0.667969 8.9987 0.667969C4.39633 0.66797 0.665364 4.39893 0.665364 9.0013C0.665364 13.6037 4.39633 17.3346 8.9987 17.3346C13.6011 17.3346 17.332 13.6037 17.332 9.0013ZM13.3927 9L12.8624 8.46967L10.3624 5.96967L9.83203 5.43934L8.77137 6.5L9.3017 7.03033L10.5214 8.25L5.66602 8.25L4.91602 8.25L4.91602 9.75L5.66602 9.75L10.5214 9.75L9.3017 10.9697L8.77137 11.5L9.83203 12.5607L10.3624 12.0303L12.8624 9.53033L13.3927 9Z",
			fill: ""
		})
	})
});
export default SvgRight;
